var Login = (function() {
    /*"use strict"; */ // Start of use strict

    var
        formLinks = null,
        loginTemplates = null;;

    var _getElements = function _getElements() {
        formLinks = document.querySelectorAll('[login-form]').toArray();
        loginTemplates = document.getElementsByClassName("login-template");
    };

    var _hideAndShow = function _hideAndShow(self) {
        var
          forms = document.querySelectorAll('.login-form').toArray(),
          formShown = document.getElementById(self.getAttribute('login-form'));

        forms.forEach(function(form) {
           form.classList.add('is-hidden');
        });
        formShown.classList.remove('is-hidden');
    };

    var _bindListeners = function _bindListeners() {
        formLinks.forEach(function(form) {
            form.addEventListener('click', function(e) {
                e.preventDefault();
                _hideAndShow(this);
            });
        });
    };

    var _scopeActiveForm = function _scopeActiveForm() {
        for(var i = 0; i < loginTemplates.length; i++)
        {
            if(loginTemplates[i].classList.contains('active')) {
                loginTemplates[i].classList.remove('is-hidden');
            }
            else {
                loginTemplates[i].classList.add('is-hidden');
            }
        }
    }

    var init = function init() {
        _getElements();
        _bindListeners();
        _scopeActiveForm();
    };

    return { init: init };
})();
